export default {
  getInventoryList: ['get', '/data_center/inventory/list'], // 盘点信息查看
  getInventory: ['get', '/data_center/inventory/trace'], // 盘点记录
  postInventoryTrace: ['post', '/data_center/inventory/trace'], // 新增盘点
  getExportRecord: ['get', '/data_center/inventory/export'], // 导出记录
  postExportRecord: ['post', '/data_center/inventory/export']
}
